export default __webpack_public_path__ + "static/media/calendar.8f7aa8ec.svg";